// console.log("loaded: block-slider-icons.js");

$('.swiper-container-icons').each(function(){

    var parentID = $(this).closest('.block-slider-icons').attr('id');
        // console.log(parentID);

    var galleryThumbs = new Swiper('#'+parentID+' .gallery-top', {
        allowTouchMove: false,
        focusableElements: '.icon-wrapper',
        slidesPerView: 4,
        spaceBetween: 0,
        touchStartForcePreventDefault: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true
    });

    var nextEl = $('#'+parentID+' .swiper-button-next');
    var prevEl = $('#'+parentID+' .swiper-button-prev');

    var attrs = {
        loop: true,
        navigation: {
            nextEl: nextEl[0],
            prevEl: prevEl[0]
        },
        pagination: {
            clickable: true
        },
        thumbs: {
            multipleActiveThumbs: false,
            swiper: galleryThumbs
        }
    };

    var mySwiper = new Swiper(this, attrs);

    // galleryThumbs.on('touchStart', function(e){
    //     console.log('galleryThumbs.slideTo(2);');
    //     console.log(e);
    //     mySwiper.slideTo(2);
    // })
})
